"use client";

import { useTheme } from "next-themes";
import { useEffect } from "react";

export function ForceLightTheme() {
  const { setTheme } = useTheme();

  useEffect(() => {
    // Sadece className olarak light atamazsak, localStorage'i da bozarız:
    // Bu yüzden document'in class objesine manuel müdahale edip theme'i de "light" yapıyor gibi davranabiliriz,
    // Ancak en doğrusu root layout'da theme provider kullanıp, anasayfada localStorage'ı bozmadan "light" class'ı vermektir.
    // Şimdilik doğrudan HTML tag'indeki dark class'ını temizliyoruz.
    document.documentElement.classList.remove("dark");
    document.documentElement.classList.add("light");
    document.documentElement.style.colorScheme = "light";
  }, []);

  return null;
}
